import get from "lodash/get";

export const getFileVersionUploadFile = state => get(state, "uploadFile.file");
export const getFileVersionUploadIsUploading = state => get(state, "uploadFile.isUploading");
export const getFileVersionUploadProgress = state => get(state, "uploadFile.progress");
export const getFileVersionUploadFinished = state => get(state, "uploadFile.uploaded");
export const getFileVersionUploadError = state => get(state, "uploadFile.error");
export const getFileVersionUploadResponse = state => get(state, "uploadFile.uploadResponse");
